import { createRoute } from '@tanstack/react-router';
import LoadingScreen from 'components/LoadingScreen';
import MainLayout from 'layouts/dashboard/MainLayout';
import { rootRoute } from 'routes/rootRoute';

export const securedParentRoute = createRoute({
  getParentRoute: () => rootRoute,
  component: () => <MainLayout />,
  path: '/secured',
  pendingComponent: LoadingScreen,
});
